import { StyledLink } from './styled';
export function MaybeLink(props) {
    const { to, children } = props;
    if (to) {
        return <StyledLink to={to}>{children}</StyledLink>;
    }
    return children;
}
